import React from 'react';
import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react';

/**
 * Blocco "bisogni" per landing orientate alle persone (non lista attività).
 * @param {{ colors: object, fontHeading: string, fontBody: string }} theme
 */
export default function LandingNeedsSection({
  theme,
  title,
  intro,
  needs = [],
  sectionId,
}) {
  if (!Array.isArray(needs) || !needs.length) return null;
  const { colors, fontHeading, fontBody } = theme;

  return (
    <Box
      id={sectionId || undefined}
      scrollMarginTop={sectionId ? '200px' : undefined}
      bg={colors.bg}
      px={4}
      py={{ base: 10, md: 12 }}
    >
      <Container maxW="container.xl">
        <Stack spacing={6}>
          {title ? (
            <Heading
              as="h2"
              fontSize={{ base: '2xl', md: '3xl' }}
              fontFamily={fontHeading}
              color={colors.text}
            >
              {title}
            </Heading>
          ) : null}
          {intro ? (
            <Text
              fontFamily={fontBody}
              color={colors.muted}
              fontSize={{ base: 'md', md: 'lg' }}
              maxW="4xl"
            >
              {intro}
            </Text>
          ) : null}
          <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={4}>
            {needs.map((need) => (
              <Box
                key={need}
                bg={colors.surface}
                borderRadius="2xl"
                px={5}
                py={4}
                borderWidth="1px"
                borderColor={colors.border}
                boxShadow="0 8px 22px rgba(0,0,0,0.06)"
              >
                <Text
                  fontFamily={fontBody}
                  color={colors.text}
                  fontSize="md"
                  fontWeight="700"
                >
                  {need}
                </Text>
              </Box>
            ))}
          </SimpleGrid>
        </Stack>
      </Container>
    </Box>
  );
}
